import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/logo_sub.png'


const _hoisted_1 = { class: "container-fluid w-100" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-12 offset-md-3 mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pr-lg-5" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-fluid my-auto",
      src: _imports_0,
      alt: "SZ-Wordly-Logo"
    })
  ])
], -1)
const _hoisted_4 = { class: "col-12 d-flex justify-content-center mt-5" }
const _hoisted_5 = { class: "h2" }
const _hoisted_6 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_7 = { class: "text-black-50" }
const _hoisted_8 = { class: "col-12 d-flex justify-content-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("messages.404")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("messages.page not found")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.loggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _ctx.homepageLink,
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("messages.back to home")), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/login/",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("messages.back to login")), 1)
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}